"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _q = _interopRequireDefault(require("q"));

function defer() {
  var reject;
  var resolve;
  var promise = new _q.default.Promise(function (fst, snd) {
    resolve = fst;
    reject = snd;
  });
  return {
    promise: promise,
    reject: reject,
    resolve: resolve
  };
}

var _default = defer;
exports.default = _default;
module.exports = exports.default;